import {
    IonButton,
    IonCard,
    IonContent,
    IonFooter,
    IonItem,
    IonLabel,
    IonPage,
    IonText,
    IonTitle,
    useIonRouter,
} from "@ionic/react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { HeaderComponent } from "../../components";
import { Geolocation } from "@capacitor/geolocation";
import { routes } from "../../route/constants";
import { useMatch } from "../../components/hooks/match";
import { GpsMap, GpsMapType } from "../../components/GpsMapComponent";
import { trackEvent } from "../../services/analytics/analyticsService";
import "../onBoarding/onBoarding.css";
import { isAndroid, isIos } from "../../services/platformDetection";
import exampleMatch from "../../support/example-result.json";
import { MatchPhone } from "refsix-js-models";

const demoMatchId = "example-result1";

export const PermissionsLocationData: FC = () => {
    const { t } = useTranslation();
    const route = useIonRouter();

    const demoMatch = useMatch(demoMatchId);
    const fallbackMatch = exampleMatch.match as unknown as MatchPhone;
    const matchForDisplay = demoMatch ?? fallbackMatch;

    const askForPermissionToUseLocation = async () => {
        if (isIos() || isAndroid()) {
            const permission = await Geolocation.checkPermissions();
            if (permission.location !== "granted") {
                await Geolocation.requestPermissions();
            }

            if (permission.location === "granted") {
                trackEvent("shareLocationData", { from: "permissions" });
            }
        }
        // Navigate to health permissions screen
        route.push(routes.permissionsHealthData, "forward", "push");
    };

    return (
        <IonPage>
            <HeaderComponent
                title={t("permissions.PermissionsDirective.title")}
                showBackButton={true}
            />
            <IonContent>
                <IonCard color="transparent">
                    <IonItem lines="none" color="transparent">
                        <IonLabel
                            className="align-center text-weight-bold uppercase"
                            color="primary"
                        >
                            {t("help.onBoarding.shareLocationData")}
                        </IonLabel>
                    </IonItem>
                    <p style={{ fontSize: 16 }}>
                        <IonText className="align-center">
                            {t("help.onBoarding.needLocationAccess")}
                        </IonText>
                    </p>
                </IonCard>

                <IonCard className="onboarding-heatmap">
                    <IonTitle color={"dark"}>{t("general.heatmap")}</IonTitle>
                    <GpsMap
                        match={matchForDisplay}
                        mapType={GpsMapType.Heatmap}
                        useDummyData={true}
                        testId="permissions-heatmap"
                    ></GpsMap>
                </IonCard>
            </IonContent>
            <IonFooter>
                <IonButton
                    data-testid="permissions-location-data-next-button"
                    expand="block"
                    onClick={() => askForPermissionToUseLocation()}
                >
                    {t("general.next")}
                </IonButton>
            </IonFooter>
        </IonPage>
    );
};
